import { render, staticRenderFns } from "./EcoCommitmentsSection.vue?vue&type=template&id=c70457a2&"
import script from "./EcoCommitmentsSection.vue?vue&type=script&lang=js&"
export * from "./EcoCommitmentsSection.vue?vue&type=script&lang=js&"
import style0 from "./EcoCommitmentsSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports